import React from 'react';
import { FormattedMessage } from 'react-intl';
import { CenterJustifiedContainer } from '../center-justified-container';
import { MobileVerticallyPaddedContainer } from './mobile-vertically-padded-container';

const EnterpriseNoJPY = () => (
  <CenterJustifiedContainer>
    <MobileVerticallyPaddedContainer>
      <FormattedMessage
        tagName={'p'}
        id="enterpriseNoJPY"
        defaultMessage="For pricing details see FAQ below or talk to our sales team"
      />
    </MobileVerticallyPaddedContainer>
  </CenterJustifiedContainer>
);

export { EnterpriseNoJPY };
